import { isCloud } from '@blk/aw-env-detection';
import { conditionalParam as baseConditionalParam, ParamExclusionRule } from '../../utils/ApiUtils';
import { userPreferenceSettings } from './Base';

export const isAGraphEnabled = () => {
  // Temporarily only using AGraph APIs externally until the legacy internal ones are fixed by AGraph team
  if (isCloud()) {
    return userPreferenceSettings.getAGraphConfig?.()?.awuserpreference ?? false;
  }
  return false;
};

/**
 * Default exclusion rules for AWUserPreferenceServer AGraph/Cloud APIs that reject unknown query params
 */
const AW_USERPREF_PARAM_EXCLUSION_RULES: ParamExclusionRule[] = [
  {
    urlPrefix: [
      'v1/recent-searches',
      '/v1/actions-filters',
      '/v1/booksync-preferences',
      '/v1/deep-dive-proposal-tabs',
      '/v1/filters',
      '/v1/recent-searches',
      '/v1/report-overrides',
      '/v1/selected-pages',
      '/v1/tou-acknowledgements',
      '/v1/uap-tou-acknowledgements',
      '/v1/user-attributes',
      '/v1/proposal-preferences',
    ],
    excludedParams: ['configurationDirectory'],
  },
];

/**
 * Returns the parameter value or undefined if it should be excluded for AWUserPreferenceServer endpoints
 * @param url - The API endpoint URL
 * @param paramName - The parameter name
 * @param value - The parameter value
 * @returns The value if not excluded, undefined otherwise
 */
export function conditionalParam<T>(url: string | undefined, paramName: string, value: T): T | undefined {
  return baseConditionalParam(url, paramName, value, AW_USERPREF_PARAM_EXCLUSION_RULES);
}
